<template>
  <div class="auth-button-component">
    <button class="btn" :disabled="disabled" @click="$emit('click')">
      <div class="button-background" />
      <loading :show="loading">
        <span>{{ text }}</span>
      </loading>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
